<template>
  <div
    :class="wrapperClassesStr"
  >
    <a
      href="#"
      :class="linkClassesStr"
      @click.prevent="$router.go(-1)"
    >
      &larr; Back
    </a>
  </div>
</template>
<script>
export default {
  props: {
    linkClasses: {
      type: Array,
      default: () => [ 'link-primary' ]
    },

    wrapperClasses: {
      type: Array,
      default: () => [ 'd-inline-block' ]
    }
  },

  computed: {
    linkClassesStr () {
      return this.linkClasses.join(' ')
    },

    wrapperClassesStr () {
      return this.wrapperClasses.join(' ')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BackBtn.vue